export const localizeJsonLD = data => ({
  ...data,
  title: data.title,
  description: data.description,
});
